export default __webpack_public_path__ + "static/media/title_merchandising.e6b8be87.png";